import axios from "axios"
import api from "./axiosInterceptor"

axios.defaults.withCredentials = true

export default async function PostData(data, url, auth) {

    if (!auth) {

        try {
            const response = await api.post(`api/${url}`, data)

            if (response.status === 200) {

                return { success: true, error: false, load: false }
            } else { return { success: false, error: true, load: false } }

        } catch (err) {
            return { success: false, error: err, load: false }
        }
    }
    else if (auth) {
        try {
            // const response = await axios.post(`${baseUrl}/${url}`,
            //     data)
            const response = await api.post(`${url}`,
                data)
            if (response.data.status === 200) {

                const usrNm = response.data.usrName
                const dbAcc = response.data.locationAccess
                const usrRole = response.data.role
                const token = response.data.tk

                return { success: true, usr: usrNm, db: dbAcc, role: usrRole, token: token, error: false, load: false }
            } else { return { success: false, error: true, load: false } }

        } catch (err) {
            return { success: false, error: err, load: false }
        }
    }
}